// getHostName :: window -> string
export const getHostName = window => (window && window.location && window.location.hostname) || '';

// domainCheck :: ([string], string) -> boolean
export const domainCheck = (domainPatterns, hostname) => {
  const domain = hostname.toLowerCase();
  return domainPatterns.some(domainPattern => domain.includes(domainPattern.toLowerCase()));
};
